import { Media, SkeletonBlock, type SkeletonProps } from "@opensea/ui-kit"

type Props = {
  variant?: SkeletonProps["variant"]
}

export function HeroHeaderViewToggleSkeleton({
  variant = "on-background",
}: Props) {
  return (
    <Media greaterThanOrEqual="lg">
      <SkeletonBlock className="aspect-square h-8 rounded" variant={variant} />
    </Media>
  )
}
